import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/static/icons/scroll-to-top.svg'


const _hoisted_1 = { class: "scroll-to-top__wrapper" }
const _hoisted_2 = ["alt"]

import { onBeforeUnmount, onMounted, ref } from "vue";

import useWebsiteTexts from "@/composables/useWebsiteTexts";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTopButton',
  props: {
  triggerDistanceFromTop: {
    type: Number,
    default: 200,
  },
},
  setup(__props) {

const props = __props



const { websiteText } = useWebsiteTexts();

const previousScrollPosition = ref(0);

let scrollButton: HTMLDivElement | null = null;

onMounted(() => {
  scrollButton = document.querySelector("#top-scroll-button");
  if (scrollButton) {
    window.addEventListener("scroll", updateScrollToTop);
    updateScrollToTop();
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateScrollToTop);
});

function scrollToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

function updateScrollToTop() {
  const isVisible =
    window.scrollY > props.triggerDistanceFromTop &&
    window.scrollY < previousScrollPosition.value;

  scrollButton!.style.opacity = isVisible ? "1" : "0";
  scrollButton!.style.pointerEvents = isVisible ? "auto" : "none";
  previousScrollPosition.value = window.scrollY;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "scroll-to-top__button",
      src: _imports_0,
      id: "top-scroll-button",
      alt: _unref(websiteText)('scroll_to_top').value,
      onClick: scrollToTop
    }, null, 8, _hoisted_2)
  ]))
}
}

})